import type { SVGProps } from "react";

export default function ShieldIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.83252 8.67993C2.83252 6.01524 2.83252 4.68292 3.14712 4.23469C3.46171 3.78647 4.71445 3.35765 7.21994 2.50001L7.69729 2.33662C9.00335 1.88955 9.65635 1.66602 10.3325 1.66602C11.0087 1.66602 11.6617 1.88955 12.9678 2.33662L13.4451 2.50001C15.9506 3.35765 17.2034 3.78647 17.5179 4.23469C17.8325 4.68292 17.8325 6.01524 17.8325 8.67993C17.8325 9.08235 17.8325 9.51885 17.8325 9.99218C17.8325 14.6905 14.3 16.9706 12.0837 17.9388C11.4825 18.2013 11.1819 18.3327 10.3325 18.3327C9.4831 18.3327 9.18252 18.2013 8.58132 17.9388C6.36499 16.9706 2.83252 14.6905 2.83252 9.99218C2.83252 9.51885 2.83252 9.08235 2.83252 8.67993Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M10.3325 6.66602V9.99935"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M10.3324 13.3327C10.7926 13.3327 11.1657 12.9596 11.1657 12.4993C11.1657 12.0391 10.7926 11.666 10.3324 11.666C9.87212 11.666 9.49902 12.0391 9.49902 12.4993C9.49902 12.9596 9.87212 13.3327 10.3324 13.3327Z"
        fill="currentColor"
      />
    </svg>
  );
}
